export default "__VITE_ASSET__BSKUn8ns__"